import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../../components/layout/Header';
import { Footer } from '../../components/layout/Footer';
import { Button } from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { StatCard } from '../../components/ui/StatCard';
import { Calendar, MapPin, Users, Recycle, ArrowRight, BookOpen, Share2, BarChart3, Leaf, AlertTriangle, Download, FileImage, Video, FileText, Clock, ChevronRight } from 'lucide-react';
// Mock data for latest content
const latestContent = [{
  id: 1,
  title: 'Poster Pilah Sampah 5 Jenis',
  type: 'Poster',
  program: 'Pilah Sampah',
  downloads: 1240,
  icon: FileImage,
  color: 'bg-green-100 text-green-600'
}, {
  id: 2,
  title: 'Video Tutorial Kompos Rumahan',
  type: 'Video',
  program: 'Edukasi',
  downloads: 856,
  icon: Video,
  color: 'bg-red-100 text-red-600'
}, {
  id: 3,
  title: 'Infografis 3R untuk Sekolah',
  type: 'Infografis',
  program: 'Edukasi',
  downloads: 2100,
  icon: FileText,
  color: 'bg-blue-100 text-blue-600'
}, {
  id: 4,
  title: 'Toolkit HPSN 2025',
  type: 'Toolkit',
  program: 'HPSN',
  downloads: 3200,
  icon: BookOpen,
  color: 'bg-purple-100 text-purple-600'
}, {
  id: 5,
  title: 'Panduan Bank Sampah Unit',
  type: 'Panduan',
  program: 'Sirkular',
  downloads: 980,
  icon: FileText,
  color: 'bg-orange-100 text-orange-600'
}, {
  id: 6,
  title: 'Poster Ramadhan Minim Sampah',
  type: 'Poster',
  program: 'Ramadhan',
  downloads: 1500,
  icon: FileImage,
  color: 'bg-teal-100 text-teal-600'
}];
// Mock data for upcoming events
const upcomingEvents = [{
  id: 1,
  title: 'Aksi Bersih Pantai Ancol',
  date: '25 Feb 2025',
  location: 'Jakarta Utara',
  participants: 150
}, {
  id: 2,
  title: 'Workshop Kompos Organik',
  date: '28 Feb 2025',
  location: 'Bandung',
  participants: 50
}, {
  id: 3,
  title: 'Susur Sungai Ciliwung',
  date: '01 Mar 2025',
  location: 'Bogor - Jakarta',
  participants: 100
}];
export function HomePage() {
  return <div className="min-h-screen bg-background flex flex-col font-sans text-foreground" data-id="element-4181">
      <Header data-id="element-4182" />

      <main className="flex-1" data-id="element-4183">
        {/* HERO SECTION */}
        <section className="relative overflow-hidden bg-gradient-to-br from-primary-700 to-secondary-700 text-white py-20 lg:py-32" data-id="element-4184">
          {/* Decorative pattern overlay */}
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-4185"></div>

          <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-4186">
            <div className="max-w-3xl" data-id="element-4187">
              <Badge className="mb-6 px-4 py-1.5 text-sm bg-white/20 text-white border border-white/30 backdrop-blur-sm font-medium" data-id="element-4188">
                Platform Resmi Pemerintah
              </Badge>
              <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6 tracking-tight" data-id="element-4189">
                Indonesia ASRI Hub
              </h1>
              <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed max-w-2xl" data-id="element-4190">
                Platform terintegrasi untuk edukasi, aksi, dan partisipasi
                masyarakat dalam pengelolaan sampah nasional.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-4191">
                <Link to="/bank-konten" data-id="element-4192">
                  <Button size="lg" className="bg-white text-primary-700 hover:bg-gray-100 font-semibold text-lg px-8 h-14 shadow-lg w-full sm:w-auto" data-id="element-4193">
                    <BookOpen className="mr-2 h-5 w-5" data-id="element-4194" />
                    Lihat Bank Konten
                  </Button>
                </Link>
                <Link to="/event" data-id="element-4195">
                  <Button size="lg" className="bg-white/20 border-2 border-white text-white hover:bg-white/30 font-semibold text-lg px-8 h-14 w-full sm:w-auto" data-id="element-4196">
                    <Calendar className="mr-2 h-5 w-5" data-id="element-4197" />
                    Ikut Event & Aksi
                  </Button>
                </Link>
                <Link to="/lapor-isu" data-id="element-4198">
                  <Button size="lg" className="bg-red-500 hover:bg-red-600 border-2 border-red-400 text-white font-semibold text-lg px-8 h-14 w-full sm:w-auto" data-id="element-4199">
                    <AlertTriangle className="mr-2 h-5 w-5" data-id="element-4200" />
                    Lapor Isu
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* STATISTIK SECTION */}
        <section className="py-8 -mt-8 relative z-20" data-id="element-4201">
          <div className="container mx-auto px-4 md:px-6" data-id="element-4202">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-4203">
              <StatCard title="Event Aktif" value="89" icon={Calendar} description="Bulan ini" data-id="element-4204" />
              <StatCard title="Lokasi Aksi" value="5,892" icon={MapPin} description="34 Provinsi" data-id="element-4205" />
              <StatCard title="Total Partisipasi" value="2.4M" icon={Users} description="Relawan & Masyarakat" data-id="element-4206" />
              <StatCard title="Tonase Terkelola" value="15.2K" icon={Recycle} description="Ton Sampah" data-id="element-4207" />
            </div>
          </div>
        </section>

        {/* SERIES AKTIF SECTION */}
        <section className="py-12 md:py-16 bg-white" data-id="element-4208">
          <div className="container mx-auto px-4 md:px-6" data-id="element-4209">
            <div className="flex items-center justify-between mb-10" data-id="element-4210">
              <div data-id="element-4211">
                <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-4212">
                  Series Tematik Aktif
                </h2>
                <p className="text-gray-600" data-id="element-4213">
                  Kampanye dan program prioritas nasional yang sedang
                  berlangsung.
                </p>
              </div>
              <Link to="/series" data-id="element-4214">
                <Button variant="ghost" className="text-primary-600 hover:text-primary-700 hover:bg-primary-50 hidden md:flex" data-id="element-4215">
                  Lihat Semua <ArrowRight className="ml-2 h-4 w-4" data-id="element-4216" />
                </Button>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-4217">
              {/* HPSN */}
              <Card className="group overflow-hidden border-0 shadow-lg hover:shadow-xl transition-all duration-300" data-id="element-4218">
                <div className="h-48 bg-gradient-to-br from-primary-500 to-primary-700 relative overflow-hidden" data-id="element-4219">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" data-id="element-4220" />
                  <div className="absolute bottom-4 left-4 z-20" data-id="element-4221">
                    <Badge className="bg-white text-primary-700" data-id="element-4222">
                      Nasional
                    </Badge>
                  </div>
                  <div className="w-full h-full flex items-center justify-center" data-id="element-4223">
                    <Calendar className="h-16 w-16 text-white/30" data-id="element-4224" />
                  </div>
                </div>
                <CardContent className="p-6" data-id="element-4225">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-primary-600 transition-colors" data-id="element-4226">
                    HPSN 2025
                  </h3>
                  <p className="text-gray-600 mb-4 line-clamp-2" data-id="element-4227">
                    Hari Peduli Sampah Nasional 2025. Atasi Sampah Plastik
                    dengan Cara Produktif.
                  </p>
                  <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-4228">
                    <Clock className="h-4 w-4 mr-1" data-id="element-4229" />
                    21 Februari 2025
                  </div>
                  <Link to="/series/hpsn-2025" data-id="element-4230">
                    <Button className="w-full bg-primary-600 text-white hover:bg-primary-700" data-id="element-4231">
                      Lihat Series
                    </Button>
                  </Link>
                </CardContent>
              </Card>

              {/* Ramadhan Minim Sampah */}
              <Card className="group overflow-hidden border-0 shadow-lg hover:shadow-xl transition-all duration-300" data-id="element-4232">
                <div className="h-48 bg-gradient-to-br from-green-500 to-teal-600 relative overflow-hidden" data-id="element-4233">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" data-id="element-4234" />
                  <div className="absolute bottom-4 left-4 z-20" data-id="element-4235">
                    <Badge className="bg-white text-green-700" data-id="element-4236">Religi</Badge>
                  </div>
                  <div className="w-full h-full flex items-center justify-center" data-id="element-4237">
                    <Leaf className="h-16 w-16 text-white/30" data-id="element-4238" />
                  </div>
                </div>
                <CardContent className="p-6" data-id="element-4239">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-primary-600 transition-colors" data-id="element-4240">
                    Ramadhan Minim Sampah
                  </h3>
                  <p className="text-gray-600 mb-4 line-clamp-2" data-id="element-4241">
                    Gerakan nasional mengurangi sampah makanan dan kemasan
                    selama bulan suci Ramadhan.
                  </p>
                  <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-4242">
                    <Clock className="h-4 w-4 mr-1" data-id="element-4243" />
                    Maret - April 2025
                  </div>
                  <Link to="/series/ramadhan-minim-sampah" data-id="element-4244">
                    <Button className="w-full bg-primary-600 text-white hover:bg-primary-700" data-id="element-4245">
                      Lihat Series
                    </Button>
                  </Link>
                </CardContent>
              </Card>

              {/* Idul Fitri */}
              <Card className="group overflow-hidden border-0 shadow-lg hover:shadow-xl transition-all duration-300" data-id="element-4246">
                <div className="h-48 bg-gradient-to-br from-amber-500 to-orange-600 relative overflow-hidden" data-id="element-4247">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" data-id="element-4248" />
                  <div className="absolute bottom-4 left-4 z-20" data-id="element-4249">
                    <Badge className="bg-white text-amber-700" data-id="element-4250">Religi</Badge>
                  </div>
                  <div className="w-full h-full flex items-center justify-center" data-id="element-4251">
                    <Recycle className="h-16 w-16 text-white/30" data-id="element-4252" />
                  </div>
                </div>
                <CardContent className="p-6" data-id="element-4253">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-primary-600 transition-colors" data-id="element-4254">
                    Idul Fitri Bersih
                  </h3>
                  <p className="text-gray-600 mb-4 line-clamp-2" data-id="element-4255">
                    Kampanye pengelolaan sampah pasca lebaran untuk lingkungan
                    yang bersih dan sehat.
                  </p>
                  <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-4256">
                    <Clock className="h-4 w-4 mr-1" data-id="element-4257" />
                    April 2025
                  </div>
                  <Link to="/series/idul-fitri-bersih" data-id="element-4258">
                    <Button className="w-full bg-primary-600 text-white hover:bg-primary-700" data-id="element-4259">
                      Lihat Series
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </div>

            <div className="mt-8 text-center md:hidden" data-id="element-4260">
              <Link to="/series" data-id="element-4261">
                <Button variant="ghost" className="text-primary-600 hover:text-primary-700 hover:bg-primary-50" data-id="element-4262">
                  Lihat Semua Series <ArrowRight className="ml-2 h-4 w-4" data-id="element-4263" />
                </Button>
              </Link>
            </div>
          </div>
        </section>

        {/* EVENT TERDEKAT SECTION */}
        <section className="py-12 md:py-16 bg-gray-50" data-id="element-4264">
          <div className="container mx-auto px-4 md:px-6" data-id="element-4265">
            <div className="flex items-center justify-between mb-10" data-id="element-4266">
              <div data-id="element-4267">
                <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-4268">
                  Event Terdekat
                </h2>
                <p className="text-gray-600" data-id="element-4269">
                  Ikuti kegiatan pengelolaan sampah di sekitarmu.
                </p>
              </div>
              <Link to="/event" data-id="element-4270">
                <Button variant="ghost" className="text-primary-600 hover:text-primary-700 hover:bg-primary-50 hidden md:flex" data-id="element-4271">
                  Lihat Kalender <ArrowRight className="ml-2 h-4 w-4" data-id="element-4272" />
                </Button>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4273">
              {upcomingEvents.map(event => <Card key={event.id} className="hover:shadow-md transition-shadow" data-id="element-4274">
                  <CardContent className="p-6" data-id="element-4275">
                    <Badge className="mb-3 bg-blue-100 text-blue-700 border-blue-200" data-id="element-4276">
                      Akan Datang
                    </Badge>
                    <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-4277">
                      {event.title}
                    </h3>
                    <div className="space-y-2 text-sm text-gray-600 mb-4" data-id="element-4278">
                      <div className="flex items-center gap-2" data-id="element-4279">
                        <Calendar className="h-4 w-4 text-gray-400" data-id="element-4280" />
                        {event.date}
                      </div>
                      <div className="flex items-center gap-2" data-id="element-4281">
                        <MapPin className="h-4 w-4 text-gray-400" data-id="element-4282" />
                        {event.location}
                      </div>
                      <div className="flex items-center gap-2" data-id="element-4283">
                        <Users className="h-4 w-4 text-gray-400" data-id="element-4284" />
                        {event.participants} Peserta Terdaftar
                      </div>
                    </div>
                    <Link to={`/event/${event.id}`} data-id="element-4285">
                      <Button className="w-full bg-primary-600 hover:bg-primary-700 text-white" data-id="element-4286">
                        Lihat Detail
                      </Button>
                    </Link>
                  </CardContent>
                </Card>)}
            </div>

            <div className="mt-8 text-center md:hidden" data-id="element-4287">
              <Link to="/event" data-id="element-4288">
                <Button variant="ghost" className="text-primary-600 hover:text-primary-700 hover:bg-primary-50" data-id="element-4289">
                  Lihat Kalender Event <ArrowRight className="ml-2 h-4 w-4" data-id="element-4290" />
                </Button>
              </Link>
            </div>
          </div>
        </section>

        {/* KONTEN TERBARU SECTION */}
        <section className="py-12 md:py-16 bg-white" data-id="element-4291">
          <div className="container mx-auto px-4 md:px-6" data-id="element-4292">
            <div className="flex items-center justify-between mb-10" data-id="element-4293">
              <div data-id="element-4294">
                <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-4295">
                  Konten Terbaru
                </h2>
                <p className="text-gray-600" data-id="element-4296">
                  Materi edukasi resmi siap unduh untuk kegiatan Anda.
                </p>
              </div>
              <Link to="/bank-konten" data-id="element-4297">
                <Button variant="ghost" className="text-primary-600 hover:text-primary-700 hover:bg-primary-50 hidden md:flex" data-id="element-4298">
                  Lihat Semua <ArrowRight className="ml-2 h-4 w-4" data-id="element-4299" />
                </Button>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4300">
              {latestContent.map(content => <Link key={content.id} to={`/content/${content.id}`} data-id="element-4301">
                  <Card className="group hover:shadow-lg transition-all duration-200 h-full border-gray-200" data-id="element-4302">
                    <CardContent className="p-0" data-id="element-4303">
                      <div className={`h-36 ${content.color} flex items-center justify-center relative overflow-hidden`} data-id="element-4304">
                        <content.icon className="h-12 w-12 opacity-40 group-hover:scale-110 transition-transform duration-300" data-id="element-4305" />
                        <div className="absolute top-3 right-3" data-id="element-4306">
                          <Badge variant="secondary" className="bg-white/90 backdrop-blur-sm shadow-sm text-xs" data-id="element-4307">
                            {content.type}
                          </Badge>
                        </div>
                      </div>
                      <div className="p-5" data-id="element-4308">
                        <Badge variant="outline" className="text-xs font-normal text-gray-500 border-gray-200 mb-2" data-id="element-4309">
                          {content.program}
                        </Badge>
                        <h4 className="text-base font-bold text-gray-900 line-clamp-2 mb-3 group-hover:text-primary-600 transition-colors" data-id="element-4310">
                          {content.title}
                        </h4>
                        <div className="flex items-center justify-between" data-id="element-4311">
                          <span className="flex items-center gap-1.5 text-sm text-gray-500" data-id="element-4312">
                            <Download className="h-4 w-4" data-id="element-4313" />
                            {content.downloads > 1000 ? `${(content.downloads / 1000).toFixed(1)}K` : content.downloads}{' '}
                            unduhan
                          </span>
                          <span className="text-sm font-medium text-primary-600 group-hover:underline flex items-center gap-1" data-id="element-4314">
                            Unduh <ChevronRight className="h-3.5 w-3.5" data-id="element-4315" />
                          </span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </Link>)}
            </div>

            <div className="mt-8 text-center md:hidden" data-id="element-4316">
              <Link to="/bank-konten" data-id="element-4317">
                <Button variant="ghost" className="text-primary-600 hover:text-primary-700 hover:bg-primary-50" data-id="element-4318">
                  Lihat Semua Konten <ArrowRight className="ml-2 h-4 w-4" data-id="element-4319" />
                </Button>
              </Link>
            </div>
          </div>
        </section>

        {/* TENTANG PLATFORM SECTION */}
        <section className="py-12 md:py-16 bg-gray-50" data-id="element-4320">
          <div className="container mx-auto px-4 md:px-6" data-id="element-4321">
            <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-4322">
              <Badge variant="secondary" className="mb-4 bg-secondary-100 text-secondary-700 hover:bg-secondary-200" data-id="element-4323">
                Tentang Indonesia ASRI Hub
              </Badge>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-4324">
                Ekosistem Pengelolaan Sampah Terintegrasi
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-4325">
                Indonesia ASRI Hub hadir sebagai hub sentral untuk menyatukan
                pemerintah, masyarakat, dan komunitas dalam satu gerakan
                nasional yang terukur dan berdampak.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-4326">
              <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-4327">
                <div className="h-16 w-16 rounded-full bg-primary-100 flex items-center justify-center mb-6 text-primary-600" data-id="element-4328">
                  <BookOpen className="h-8 w-8" data-id="element-4329" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-4330">
                  Edukasi Terpadu
                </h3>
                <p className="text-gray-600" data-id="element-4331">
                  Akses ribuan materi KIE terstandar nasional. Poster, video,
                  dan modul pembelajaran siap pakai.
                </p>
              </div>

              <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-4332">
                <div className="h-16 w-16 rounded-full bg-secondary-100 flex items-center justify-center mb-6 text-secondary-600" data-id="element-4333">
                  <Share2 className="h-8 w-8" data-id="element-4334" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-4335">
                  Aksi Terkoordinasi
                </h3>
                <p className="text-gray-600" data-id="element-4336">
                  Manajemen event dan aksi bersih terintegrasi. Dari pendaftaran
                  hingga pelaporan hasil.
                </p>
              </div>

              <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-4337">
                <div className="h-16 w-16 rounded-full bg-blue-100 flex items-center justify-center mb-6 text-blue-600" data-id="element-4338">
                  <BarChart3 className="h-8 w-8" data-id="element-4339" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-4340">
                  Data Transparan
                </h3>
                <p className="text-gray-600" data-id="element-4341">
                  Pantau capaian kinerja pengelolaan sampah daerah secara
                  real-time dengan dashboard interaktif.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA SECTION */}
        <section className="py-16 md:py-20 bg-gradient-to-br from-primary-700 to-secondary-700 text-white" data-id="element-4342">
          <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-4343">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-4344">
              Siap Berkontribusi untuk Indonesia?
            </h2>
            <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto" data-id="element-4345">
              Laporkan isu lingkungan di sekitarmu, ikuti survei, atau bergabung
              dalam aksi nyata pengelolaan sampah.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-4346">
              <Link to="/lapor-isu" data-id="element-4347">
                <Button size="lg" className="bg-red-500 hover:bg-red-600 text-white font-semibold text-lg px-8 shadow-lg w-full sm:w-auto" data-id="element-4348">
                  <AlertTriangle className="mr-2 h-5 w-5" data-id="element-4349" />
                  Lapor Isu Lingkungan
                </Button>
              </Link>
              <Link to="/partisipasi" data-id="element-4350">
                <Button size="lg" className="bg-white/20 border-2 border-white text-white hover:bg-white/30 font-semibold text-lg px-8 w-full sm:w-auto" data-id="element-4351">
                  Ikut Partisipasi
                </Button>
              </Link>
              <Link to="/komunitas" data-id="element-4352">
                <Button size="lg" className="bg-white text-primary-700 hover:bg-gray-100 font-semibold text-lg px-8 w-full sm:w-auto" data-id="element-4353">
                  Daftar Komunitas
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-4354" />
    </div>;
}